module.exports = __webpack_public_path__ + "img/max-file-content-signature-edit.eba97155.svg";